
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 45 45","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.724 17.101L2.069 28.997l4.137-3.103 3.22.637c1.288-3.372 2.773-6.31 4.388-8.88l-7.09-.55zM27.411 37.789l-11.896 4.654 3.103-4.137-.637-3.22c3.372-1.287 6.311-2.772 8.88-4.388l.55 7.09z","fill":"#afb6bb","fill-rule":"nonzero"}}),_c('path',{attrs:{"d":"M11.767 33.59l-.844-.844c-2.131-1.61-5.268-.673-6.386 1.784L0 44.512l9.982-4.537c2.458-1.117 3.395-4.255 1.785-6.386z","fill":"#ebba16","fill-rule":"nonzero"}}),_c('path',{attrs:{"d":"M44.48.033S19.653-2.036 8.792 26.411l9.31 9.31C46.547 24.858 44.479.032 44.479.032z","fill":"#e7eced","fill-rule":"nonzero"}}),_c('path',{attrs:{"d":"M21.489 23.024h-5.172l-6.49 11.662 11.662-7.058v-4.604z","fill":"#afb6bb","fill-rule":"nonzero"}}),_c('path',{attrs:{"d":"M29.083 3.257L41.255 15.43C45.069 7.15 44.478.033 44.478.033s-7.116-.59-15.395 3.224z","fill":"#2196f3","fill-rule":"nonzero"}}),_c('circle',{attrs:{"cx":"28.442","cy":"16.067","r":"5.851","fill":"red","transform":"rotate(.096 0 0)"}})])
          )
        }
      }
    